import _ from 'lodash'

const hotspotsAnchorCorrections = {
  x: 4.40,
  y: 10.57,
  z: 2.76
}

let contents = {
  '0':{

    hotspotAnchor: {x:0+hotspotsAnchorCorrections.x/4,y:11,z:0+hotspotsAnchorCorrections.z},
    hotspotAngle: 0,
    hotspotDistance: 500,

    id: 0,
    position: 0,
    offset: 0,
    margin: 0,
    showMarker: false,
    showAnchor: false,
    activeInScene: false,
    title: "",
    intro: "",
    text: ""
  },
  '1':{

    hotspotAnchor: {x:-1.201,y:17.922,z:2.399},
    hotspotAngle: - Math.PI * 0.85,
    hotspotDistance: 200,

    id: 1,
    position: 1,
    offset: 0,
    margin: 0,
    showMarker: true,
    showAnchor: true,
    activeInScene: true,
    title: "Top Module",
    intro: "Is it ever *not* lonely at the top?",
    text: "Is it ever *not* lonely at the top? This, perhaps, is the very meaning of ascension, politically speaking: the higher up and the farther we go, the greater the likelihood that we’ll go so alone. The top of any pyramid typically only ever houses one – not two, not three, not more. Up here, in isolation station, only my self seems larger than life; down below, splendidly detached, the world looms but little indeed. Up here, in quarantine central, one cannot help but look outward and ahead, to the cold above and beyond. And looking back, the devilish events of 2020-2021 will seem like a crash course in cockpit living."
  },
  '2':{

    hotspotAnchor: {x:-1.019,y:19.689,z:2.399},
    hotspotAngle: -Math.PI/1.85,
    hotspotDistance: 100,

    id: 2,
    position: 2,
    offset: 0,
    margin: 0,
    showMarker: true,
    showAnchor: true,
    activeInScene: true,
    title: "Window",
    intro: "If the eyes have been called the window of the soul, then this window staring into the void of space may well be the eye of providence – foreseeing the end of the world as we know it…",
    text: "If the eyes have been called the window of the soul, then this window staring into the void of space may well be the eye of providence – foreseeing the end of the world as we know it, in which not a soul will be left standing. Indeed, these windows on the world are fogging up fast, with the damp of ever-increasing extreme weather events and the dust of Californian forest fires clogging the view ahead – or back. Eyes are for seeing horrors, vision for the viewing of catastrophes, so let’s make sure we get some extra opaque blinds installed, shall we?"
  },
  '3':{

    hotspotAnchor: {x:1.102,y:18.186,z:1.483},
    hotspotAngle: -Math.PI / 1,
    hotspotDistance: 150,

    id: 3,
    position: 3,
    offset: 0,
    margin: 0,
    showMarker: true,
    showAnchor: true,
    activeInScene: true,
    title: "Bridge",
    intro: "“Only to humanity, in contrast to nature, has the right to connect and separate been granted”,",
    text: "“Only to humanity, in contrast to nature, has the right to connect and separate been granted”, a great German scholar of the inner workings of western civilization once opined in a finely titled essay “Bridge and Door” (*not* “Bridge and Tunnel”). “The bridge”, according to said wise guy, “symbolizes the spreading of our will through space. The bridge encourages the eye to inter- relate parts of the landscape just as in practical reality it encourages bodies to relate with one another”. The door, on the other hand, “is the line of demarcation where the limited and the limitless meet, but not in the dead geometrical form of merely a partition wall, but rather as the permanent possibility of continuous alternation.” The story of Bridge ’n’ Door, however, also brings to mind the entirely conceivable possibility of *using a door as a bridge* – of “connecting people” otherwise."
  },
  '4':{

    hotspotAnchor: {x:1.0,y:19.5,z:2.5},
    hotspotAngle: - Math.PI / 0.8,
    hotspotDistance: 70,

    id: 4,
    position: 4,
    offset: 0,
    margin: 0,
    showMarker: true,
    showAnchor: true,
    activeInScene: true,
    title: "Door",
    intro: "Doors, portals: you never really know what lurks behind them.",
    text: "Doors, portals: you never really know what lurks behind them. A most dependable staple of the gothic imagination, in other words. Oh – and the phobia of shutting a door behind oneself without checking who’s got the keys! Ghoulish symbols of the myth of possibility, doors exude the unsettling uncertainty of the quantum world: they don’t always have to be either open or closed (on or off, inside or out), they can be… spookily *ajar*. Horrors! They might not be inanimate objects after all, but the true arbiters who’s in and who’s out, who’s going and who’s staying. Doors *eat people*!"
  },
  '5':{

    hotspotAnchor: {x:3.405,y:14.969,z:2.399},
    hotspotAngle: -Math.PI / 1.1,
    hotspotDistance: 350,

    id: 5,
    position: 5,
    offset: 0,
    margin: 0,
    showMarker: true,
    showAnchor: true,
    activeInScene: true,
    title: "Launch Tower",
    intro: "Let us think of the life of the mind as a forest full of trees – which one would you pick to climb into? *Will I get it up*?",
    text: "An Austro-British philosopher of genius suggested once that his propositions “serve as elucidations in the following way: anyone who understands me eventually recognizes them as nonsensical, when he has used them—as steps—to climb beyond them. (He must, so to speak, throw away the ladder after he has climbed up it.)” This sage famously made a philosophical career out of contradicting and undermining his younger self, and later opined that “anything that I might reach by climbing a ladder does not interest me.” Right – but what did he think of putting it up against in the first place? The celestial vault, perhaps? Or just, well, a *tree*? Let us think of the life of the mind as a forest full of trees – which one would you pick to climb into? *Will I get it up*?"
  },
  '6':{

    hotspotAnchor: {x:1.102,y:14.969,z:3.617},
    hotspotAngle: - Math.PI / 1,
    hotspotDistance: 100,

    id: 6,
    position: 6,
    offset: 0,
    margin: 0,
    showMarker: true,
    showAnchor: true,
    activeInScene: true,
    title: "Cables",
    intro: "What, I ask, more painfully embodies the illusory, unfulfillable promise of mobility than our titanic daily tussle with *cables*?",
    text: "What, I ask, more painfully embodies the illusory, unfulfillable promise of mobility than our titanic daily tussle with *cables*? The bloody things drive me absolutely bonkers: the cable to my TV, the cable to my smartphone, the cable to my laptop charger, always tangling up with the wires from which I hang my glasses, my headphones, my ever-changing collection of necklaces. No wonder the ancient sculpture of Laocoon and his writhing sons being attacked by a sea serpent remains so perennially topical, contemporary even: cables conjure the mirage of movement, yet forever keep us chained in place. We’re never going to get anywhere all tangled up in these so-called power cords."
  },
  '7':{

    hotspotAnchor: {x:-0.984,y:18.404,z:1.992},
    hotspotAngle: -Math.PI * 0.5,
    hotspotDistance: 75,

    id: 7,
    position: 7,
    offset: 0,
    margin: 0,
    showMarker: true,
    showAnchor: true,
    activeInScene: true,
    title: "Fins",
    intro: "Slow Your Roll, Earthlings!",
    text: "Slow Your Roll, Earthlings! These here fins will keep us on course, as well as on time – for “the purpose of putting fins on a rocket is to provide stability during flight, that is, to allow the rocket to maintain its orientation and intended flight path.” Our intended flight path suggests we get the f** out of here – unless, that is, we do slow our roll and step on the global warming brakes, say. We better be on course for something better than the fate usually spelled out by the appearance of fins in popular media. (Cue the eerie musical theme announcing the coming of *Jaws*’ lethal great white.)"
  },
  '8':{

    hotspotAnchor: {x:-1.150,y:14.837,z:2.451},
    hotspotAngle: -Math.PI * .75,
    hotspotDistance: 175,

    id: 8,
    position: 8,
    offset: 0,
    margin: 0,
    showMarker: true,
    showAnchor: true,
    activeInScene: true,
    title: "Middle Module",
    intro: "Indeed, here we are, right in the middle – and where do we go from here?",
    text: "QAnon is the well-known name of an absolutely bonkers conspiracy theory flourishing on the fringes of the American right and alleging that a secret cabal of Satan-worshipping, man-eating pedophiles of the Democrat persuasion ran (or continue to run) a sex-trafficking ring operating, in part, out of the basement of a restaurant named Comet (!) Ping Pong Pizzeria in Washington’s verdant Chevy Chase neighborhood. In December 2016, this restaurant received the surprise visit of a heavily-armed 28-year-old man intent on rescuing the children allegedly locked up in its basement. Or how about the Christmas day bombing outside an AT&amp;T building in Nashville in December 2020, perpetrated by a loner who appeared to have believed that a great number of powerful politicians (on the American Left, naturally) and Hollywood figures are actually lizard people of uncertain extraterrestrial origin set to take over Planet Earth? Indeed, here we are, right in the middle – and where do we go from here? Ahead, the dark and desolation of deep space – not a sunny prospect by any stretch of the imagination. But down below, on what we have long agreed to call Earth, the blinding light of madness all around. Up or down – it’s some call."
  },
  '9':{

    hotspotAnchor: {x:-1.002,y:10.985,z:3.767},
    hotspotAngle: -Math.PI / .95,
    hotspotDistance: 200,

    id: 9,
    position: 9,
    offset: 0,
    margin: 0,
    showMarker: true,
    showAnchor: true,
    activeInScene: true,
    title: "Boosters",
    intro: "Gravity’s a drag – on the GDP.",
    text: "Gravity’s a drag – on the GDP. It seems baffling to be reminded, in these times of seemingly endless exponential growth of computing power - of cloning first sheep and then humans, of the boundless capacities of artificial intelligence - that it’s been close to half a century since men last walked on the moon; 14 December 1972, to be precise. We all know the reason, of course: the expense, first and foremost – the cost of flying men to the moon had become a tad too… well, *astronomical*. And secondly, by the crisis-plagued early seventies the exercise seemed to have become politically pointless. Today’s dreams of space travel emerge in a thoroughly post-political world – the ideal playground for billionaires, in other words. Leave it to the likes of Bezos and Musk to lube the boosters of our rockets to the future."
  },
  '10':{

    hotspotAnchor: {x:-0.822,y:13.338,z:1.593},
    hotspotAngle: -Math.PI / 1.5,
    hotspotDistance: 50,

    id: 10,
    position: 10,
    offset: 0,
    margin: 0,
    showMarker: true,
    showAnchor: true,
    activeInScene: true,
    title: "Bolts",
    intro: "Do bolts drive us nuts? Whosoever was ever nuts about bolts?",
    text: "Do bolts drive us nuts? Whosoever was ever nuts about bolts? The very word – that meaning “a bar that slides into a socket to fasten a door or window”, not “a short, heavy arrow shot from a crossbow”, much less a *thunderbolt* – conjures nightmarish visions of tightening of the least pleasant kind. Its very specter makes me want to bolt for the nearest exit – which did just happen to be named “Brexit”. Like the straps and screws that hold us fast in an electric chair of sorts, the bolts’ rightward turn begs the sardonic question: how close, snug and tight do you want us to be? This torture cozy enough for you?"
  },
  '11':{

    hotspotAnchor: {x:-1.120,y:10.328,z:2.436},
    hotspotAngle: -Math.PI / 1.75,
    hotspotDistance: 175,

    id: 11,
    position: 11,
    offset: 0,
    margin: 0,
    showMarker: true,
    showAnchor: true,
    activeInScene: true,
    title: "Bottom Module",
    intro: "When will the bottom fall out? You can always ask the Doomsday Clock…",
    text: "When will the bottom fall out? You can always ask the Doomsday Clock, the infamous symbol denoting the likelihood of an impending man-made global catastrophe. Early on in 2021, in the intractable shadow of the coronavirus pandemic, it read one hundred seconds to midnight. This, in fact, is the closest the clock’s arms have ever been to midnight – full-blown apocalypse. The Doomsday Clock was founded by a troupe of University of Chicago scientists who had been involved in the Manhattan Project’s making of the atom bomb, and when the clock was first unveiled in 1947, it was seven to midnight. (The safest we’ve ever been was back in 1991, a little more than a luxurious quarter to twelve.) The bottom line? Prepare for take-off."
  },
  '12':{

    hotspotAnchor: {x:-1.150,y:8.271,z:2.451},
    hotspotAngle: -Math.PI / 1.5,
    hotspotDistance: 80,

    id: 12,
    position: 12,
    offset: 0,
    margin: 0,
    showMarker: true,
    showAnchor: true,
    activeInScene: true,
    title: "Engines",
    intro: "What will power us on our journey back to reason? What will lift our spirits? Planet Earth is running on empty, and these are tough times for the godless.",
    text: "What will power us on our journey back to reason? What will lift our spirits? Planet Earth is running on empty, and these are tough times for the godless. The good news is there are plenty of renewable energy sources to plug into – plenty of places to get our spiritual batteries recharged, lots of rocket fuel to choose from. What will your poison be, dear rocket? Name the cause that will cause you to take off. Shall I fire thee with some high-grade environmental angst, or will the fight to end poverty on earth do? And do I see… Bill Gates at the pump?? Mark Zuckerberg fingering your sockets?? Oy."
  },
  '13':{

    hotspotAnchor: {x:0+hotspotsAnchorCorrections.x/4,y:12,z:0+hotspotsAnchorCorrections.z},
    hotspotAngle: -Math.PI / 1.1,
    hotspotDistance: 600,

    id: 13,
    position: 13,
    offset: 0,
    margin: 0,
    showMarker: false,
    showAnchor: false,
    activeInScene: false,
    title: "",
    intro: "",
    text: ""
  },
}

contents = _.map(contents, (v,i)=>{
  console.log('contents v i', i, v)
  v.hotspotAnchor.x-=hotspotsAnchorCorrections.x/4
  v.hotspotAnchor.y-=hotspotsAnchorCorrections.y
  v.hotspotAnchor.z-=hotspotsAnchorCorrections.z
  return v
})

export {contents}
